import { USER_CLICK_EVENT } from 'src/constants/MonitoringConstants';
import { recordRumEvent } from './rum';

export type ElementType = 'button' | 'card' | 'link' | 'nav' | 'form';

export interface ClickEventPayload {
  elementId: string;
  elementType: ElementType;
  pageGroup: string;
  metadata?: Record<string, string | number | boolean>;
}

export const trackClick = ({
  elementId,
  elementType,
  pageGroup,
  metadata,
}: ClickEventPayload): void => {
  recordRumEvent(USER_CLICK_EVENT, {
    ...metadata,
    element: `${pageGroup}_${elementId}`,
    elementId,
    elementType,
    pageGroup,
  });
};
